import Model, { attr, belongsTo } from '@ember-data/model';
import type CompanyModel from './company.ts';
import type EmployeeModel from './employee.ts';
import { Type } from '@warp-drive/core-types/symbols';

export type LedgerAccountType = 'ASSET' | 'LIABILITY' | 'EQUITY' | 'REVENUE' | 'EXPENSE';
export type LedgerAccountSubtype = string; // TODO: @hayley define these
export type LedgerProduct = 'SLR' | 'TA';

export default class LedgerAccountModel extends Model {
  @attr declare name: string;
  @attr declare accountType: LedgerAccountType;
  @attr declare accountSubtype: LedgerAccountSubtype;
  @attr declare product: LedgerProduct;
  @attr declare metadata: Record<string, unknown> | null;
  @attr declare balance: number;

  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel;

  @belongsTo('employee', { async: false, inverse: null })
  declare employee: EmployeeModel | null;

  [Type] = 'ledger-account' as const;
}
